import axios, { Method, AxiosRequestConfig } from "axios";
import { PublicConfig } from "../PublicConfig";

export class MCUserAPI {
    private token: string;

    constructor(token: string) {
        this.token = token;
    }

    private async call<T = any>(method: Method, endpoint: string, options: AxiosRequestConfig = {}): Promise<T> {
        const url = PublicConfig.PTZ_US.UNDERWRITER_API_BASE_URL + endpoint;
        const request = await axios(url, {
            ...options,
            method,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${this.token}`
            }
        });
        return request.data;
    }

    async getUser(): Promise<any> {
        return this.call("GET", "/mc-user");
    }
}
